import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import GrafanaWarning from "./Warning";

const PostIframe = ({
  title,
  url,
  variableKeys,
  showOnlyIcon,
  panelId,
  variableObject,
  className,
  postFilterList,
  width,
  height,
  divId,
}) => {
  const createIframeElement = (container) => {
    const shouldAppendIframe = variableKeys?.every(
      (variable) =>
        variableObject?.hasOwnProperty(variable) &&
        variableObject[variable] !== null &&
        variableObject[variable] !== undefined
    );
    let urlWithParams;

    if (shouldAppendIframe && Object.keys(postFilterList).length > 0) {
      urlWithParams = `${url}${variableKeys
        .map((variable) =>
          variable === "orgId"
            ? `${variable}=${variableObject[variable]}`
            : ["from", "to", "refresh"].includes(variable)
            ? `&${variable}=${variableObject[variable]}`
            : `&var-${variable}=${variableObject[variable]}`
        )
        .join("")}`;

      urlWithParams = `${urlWithParams}&panelId=${panelId}`;

      const iframe = document.createElement("iframe");
      iframe.title = title;
      iframe.src = urlWithParams;
      iframe.width = width;
      iframe.height = height;
      iframe.className = className ? `${className} box-shadow` : "box-shadow";
      iframe.frameBorder = "0";
      iframe.setAttribute("data-testid", "post-iframe");
      container.appendChild(iframe);
      const formData = new FormData();
      Object.keys(postFilterList).forEach((key) => {
        postFilterList[key].forEach((value) => {
          formData.append(`var-${key}`, value);
        });
      });

      fetch(urlWithParams, {
        method: "POST",
        body: formData,
      });
    } else {
      const divElement = document.createElement("div");
      divElement.className = "no-iframe flex-center";
      divElement.style.width = width;
      divElement.style.height = `${height}px`;
      divElement.setAttribute("data-testid", "no-post-iframe");

      const root = ReactDOM.createRoot(divElement);
      root.render(<GrafanaWarning width={width} showOnlyIcon={showOnlyIcon} />);

      container.appendChild(divElement);
    }
  };

  useEffect(() => {
    const container = document.getElementById(divId);
    createIframeElement(container);
    return () => {
      const iframe = container.querySelector("iframe[data-testid=post-iframe]");
      if (iframe) {
        container.removeChild(iframe);
      } else {
        const divElement = container.querySelector(".no-iframe");
        if (divElement) {
          container.removeChild(divElement);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divId, variableObject]);

  return <></>;
};

export default PostIframe;
